
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.29501 8.29474C5.68836 7.90175 6.3261 7.90175 6.71945 8.29474L12 13.5705L17.2805 8.29474C17.6739 7.90175 18.3116 7.90175 18.705 8.29474C19.0983 8.68774 19.0983 9.3249 18.705 9.7179L12.7122 15.7053C12.3189 16.0982 11.6811 16.0982 11.2878 15.7053L5.29501 9.7179C4.90166 9.3249 4.90166 8.68774 5.29501 8.29474Z","fill":"#10001F"}})])
          )
        }
      }
    